import jquery from "jquery"
import Rails from "@rails/ujs"
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import * as bootstrap from "bootstrap"
import ApexCharts from "apexcharts"
import "trix"

window.$ = jquery
window.jQuery = jquery

Rails.start()
window.Rails = Rails

ActiveStorage.start()

window.bootstrap = bootstrap
window.ApexCharts = ApexCharts

const select2 = await import("select2/dist/js/select2.full")
const installSelect2 = select2.default || select2
installSelect2(window, jquery)

const tomSelect = await import("tom-select/dist/js/tom-select.complete.js")
window.TomSelect = tomSelect.default || tomSelect

await import("@rails/actiontext")
await import("./controllers")
await import("./bootstrap_jquery")
await import("./legacy")
